import { buildsServiceApi } from "../../api";

export const removeProjectAdmin = async (projectId: string, userId: string) => {
  return buildsServiceApi.delete(`/projects/${projectId}/admin`, {
    data: { userId },
  });
};
